//fichier de contexte pour les variables globales

import React from 'react';
const Contexte = React.createContext({}); //creation du contexte

export default Contexte; //export du contexte